import { createSelector } from 'reselect';
import { playerModalSelector } from './simple-selector';

export const PlayerModalLeaderboardDataSelector = createSelector(
    playerModalSelector,
    (playerModal) => playerModal.leaderBoardData
);
